export default __webpack_public_path__ + "static/media/fontainebleau3.b93164d7.jpg";